import styled from 'styled-components';
import { Container } from 'components/structure';

export const Wrapper = styled(Container)``;

export const Content = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
`;
